import store from '@/store';
export const webSocketMixins = {
    data(){
        return {
            webSocket: null,
            webSocketUrl: null,
            lockReconnect : false, //避免ws重复连接
            connectCount: 0,
            //检测心跳
            heartCheckTime: 180000,  //心跳检测时间
            heartCheckMsg: 'hello',
            heartCheckTimer: null, //心跳检测计时器
            webSocketCloseTimer: null, //服务关闭计时器
            
        }
    },
    methods:{
        //初始化webSocket
        initWebSocket(url) {
            this.webSocketUrl = url;
            this.webSocket = new WebSocket(url);
            // this.webSock.onmessage = this.webSocketOnMessage;
            this.webSocket.onopen = this.webSocketOnOpen;
            this.webSocket.onclose = this.webSocketOnClose;
            this.webSocket.onerror = this.webSocketOnError;
        },
        //webSocket打开监听事件
        webSocketOnOpen() {
            console.log("open")
            //连接建立之后执行send方法发送数据
            this.webSocketSend(this.heartCheckMsg);
        },
        webSocketOnClose(e) {
            console.log("close", e);
            this.connectCount ++;
            if(this.connectCount < 5){ //防止一直在重复链接, 限制次数
                this.reconnect();
            }
        },
        webSocketOnError(e) {
            console.log("error", e)
        },
        //重新链接
        reconnect() {
            if(this.lockReconnect) return;
            this.lockReconnect = true;
            setTimeout(()=> {     //没连接上会一直重连，设置延迟避免请求过多
                this.initWebSocket(this.webSocketUrl);
                this.lockReconnect = false;
            }, 2000);
        },
        //webSocket向后端发送信息
        webSocketSend(data) {
            //数据发送
            this.webSocket.send(data);
        },
        //webSocket收到信息
        webSocketOnMessage(e) {
            const data = JSON.parse(e.data);
            console.log(data);
        },
        webSocketOnAlarmMessage(e){
            this.heartCheckReset();
            this.heartCheckStart();
            if(e.data !== this.heartCheckMsg){
                const data = JSON.parse(e.data).content;
                store.commit('initMessageBox', {
                    title: data.siteTypeName,
                    duration: 30000,
                    show: true,
                    icon: "icon-alarm",
                    message: data.name + '-' + data.siteName,
                    type: "alarm"
                })
                store.commit("updateAlarm", data.alarmNum);
                store.commit("updateWarning", data.warningNum);
            }
        },
        
        /**心跳检测**/
        //重置心跳
        heartCheckReset(){
            clearTimeout(this.heartCheckTimer);
            clearTimeout(this.webSocketCloseTimer);
        },
        //开始心跳
        heartCheckStart(){
            this.heartCheckTimer = setTimeout(() => {
                //这里发送一个心跳，后端收到后，返回一个心跳消息，
                //onmessage拿到返回的心跳就说明连接正常
                this.webSocketSend(this.heartCheckMsg);
                this.webSocketCloseTimer = setTimeout(() => {//如果超过一定时间还没重置，说明后端主动断开了
                    this.webSocket.close();     //如果onclose会执行reconnect，我们执行ws.close()就行了.如果直接执行reconnect 会触发onclose导致重连两次
                }, this.heartCheckTime)
            }, this.heartCheckTime)
        },
    }
}